
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import {
  SistemaMixin,
  ValidacaoMixin,
  PessoaMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeContratos";
import { ClienteDataRequired } from "../ClienteData";

export default {
  name: "app-contrato-form-cliente",
  components: {
    VueSelect,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      emissao: null,
      firstLoad: false,
      clientSelected: {
        cnpj_cpf: null,
      },
      clients: [],
      clienteFilled: false,
      clienteError: false,
      enderecoError: false,
      enderecoFilled: false,
      keyToReRender: 0,
      enderecos: [],
      realizar_reducao: false,
      calcular_substituicao: false,
      nomeCliente: null,
      cpfCnpjCliente: null,
      cidades: [],
      formEndereco: {},
    };
  },
  validations: {
    form: ClienteDataRequired,
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, PessoaMixin],
  methods: {
    ...mapActions(["setLoading"]),
    onSearchEmail() {},
    onSearchCliente(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clients = await vm.getClientes(search);
      loading(false);
    }, 350),
    setCliente(cliente) {
      if (!cliente) return;
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.store.formCliente = {};
        this.clienteFilled = false;
        this.enderecos = [];
        this.keyToReRender++;
        return;
      }

      this.store.formCliente = cliente;
      this.clienteFilled = true;
      this.enderecos = cliente.enderecos;
      this.store.formCliente.endereco = cliente.enderecos[0];

      if (cliente.emails.length > 0) {
        this.store.formInformacoes.email_fatura = cliente.emails[0].email;
      }
      this.keyToReRender++;
    },
    async getCliente(id_pessoa) {
      const pessoa = await this.getPessoa(id_pessoa);
      this.store.formCliente = {
        ...this.store.formCliente,
        ...pessoa,
      };
    },
    searchEndereco: _.debounce(async (loading, search, vm) => {
      vm.enderecos = vm.enderecos.filter((endereco) =>
        endereco.includes(search)
      );
      loading(false);
    }, 350),
    onSearchEndereco(search, loading) {
      if (search.length) {
        loading(true);
        this.searcEndereco(loading, search, this);
      }
    },
    setEndereco(endereco) {
      this.formCliente.endereco = endereco;
      this.keyToReRender++;
      this.enderecoFilled = true;
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
        endereco?.cidade?.cidade ?? ""
      } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { cliente } = this.$route.params.contratoData;
      this.setCliente(cliente);
      this.setEndereco(cliente.enderecos);
    } else {
      this.store.formCliente = {};
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0;
    },
    valueAdress() {
      return this.store.formCliente?.endereco
        ? this.formatEndereco(this.store.formCliente.endereco)
        : null;
    },
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        if (_.isEmpty(this.store.formCliente)) {
          this.$toast.error("Selecione o cliente!");
          this.store.currentTab = oldValue;
          return;
        }
        if (_.isEmpty(this.store.formCliente.endereco)) {
          this.$toast.error("Selecione um endereço!");
          this.store.currentTab = oldValue;
        }
      }
    },
  },
};
